import { Injectable, signal } from '@angular/core';

/**
 * Change chaque fois que le jeton a été renouvelé parce que les droits de l'utilisateur ont pu
 * changer (`dode:profil`, contrat des logiciels § 4.7) : ce qui affiche selon les rôles le relit
 * pour se redessiner, sans reconnexion.
 */
@Injectable({ providedIn: 'root' })
export class RolesRevision {
  private readonly revision = signal(0);
  readonly value = this.revision.asReadonly();

  bump(): void {
    this.revision.update((value) => value + 1);
  }
}
